import AppHeader from '@/components/Elements/Header/AppHeader';
import { Box, Button, Grid } from '@mui/material';
import { ColorPalettes } from '../constants/ColorPalettes';
import { useMemberstatus } from '@/hooks/useMemberstatus';

/**
 * 会員未登録コンポーネント。
 * @param attribute 属性（エクソソーム会員、ビタミン会員）
 * @returns
 */
export function NotUserRegistration() {
  const { getMemberstatusNames } = useMemberstatus();
  const attr = getMemberstatusNames().join('・') + '会員未登録';
  return (
    <>
      <AppHeader title={attr} />
      <Box sx={{ p: 2 }}>
        <Grid container direction={'row'} justifyContent={'center'} spacing={2} sx={{ mt: 4 }}>
          <Grid item sx={{ mt: 2 }} textAlign={'center'} xs={12}>
            LINEへ戻り
            <br />
            会員登録をしてください
          </Grid>
          <Button
            sx={{
              mt: 2,
              bgcolor: ColorPalettes.MAIN,
              color: ColorPalettes.WHITE,
              fontSize: 16,
              width: 240
            }}
            onClick={() => {
              window.close();
            }}
          >
            LINEへ戻る
          </Button>
        </Grid>
      </Box>
    </>
  );
}
